<template>
  <SmartFeed
    :source="useMyDigitalProductPurchaseFeedStore"
    default-feed-layout="table"
    default-entity-size="tableRow"
    :edit-mode="editMode"
  >
    <template #empty-state>
      <iSpace :height="10" />
      <iColumn gap="large" align="center">
        <iColumn gap="standard" align="center">
          <iSubHeading variant="subtle" font-size="large">
            No digital product purchases yet
          </iSubHeading>
          <iParagraph
            variant="subtle"
            text-align="center"
            :max-width="400"
          >
            Your digital products will appear here.
          </iParagraph>
        </iColumn>
      </iColumn>
    </template>
  </SmartFeed>
</template>

<script>
import SmartFeed from "SmartFeed/components/SmartFeedV2.vue";
import { useMyDigitalProductPurchaseFeedStore } from "SmartFeed/stores/feed/my-digital-product-purchase-feed-store";
import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import LayoutWidth from "%/dynamic-component-editor/options/layout-width";
import EmptyStateText from "%/dynamic-component-editor/options/empty-state-text";

export default {
  name: "MyPurchasedDigitalProducts",
  components: {
    SmartFeed,
  },
  mixins: [
    DynamicElementMixin,
  ],
  elementPanelSettings: {
    displayName: "Purchased Digital Products",
    displayIcon: "feed",
    elementGroup: "purchasedDigitalProductsElements",
    elementType: "element",
  },
  options: [
    new LayoutWidth({
      "default": "fill",
      "hover": "fill",
    }, true),
    new EmptyStateText({ "default": "You have not purchased any digital products yet." }),
  ],
  methods: {
    useMyDigitalProductPurchaseFeedStore,
  },
};
</script>

<style scoped lang="scss">
</style>
